/* eslint-disable import/prefer-default-export */
const LightThemeColors = [
  {
    name: 'BLUE_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'AQUA_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'PURPLE_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'GREEN_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'CYAN_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'ORANGE_THEME',
    palette: {
      primary: {
        main: '#FF7235',
        light: '#FFF1EB',
        dark: '#E5622A',
        // White on this orange is 2.72:1, under the 4.5:1 body text needs. #040433 is 7.20:1.
        contrastText: '#040433',
      },
      secondary: {
        main: '#5D3CBF',
        light: '#EEE8FF',
        dark: '#4B2EA2',
        contrastText: '#ffffff',
      },
    },
  },
];

// eslint-disable-next-line import/prefer-default-export
export { LightThemeColors };
